/**
 * ROUTES
 *
 * ===============================================
 *
 * This object depicts the component url structure.
 * It contains a key-value pair of components and their respective URLs
 *
 */

export const Routes = {
  // =============================================
  // SHARED ROUTES (V1 & V2)
  // =============================================

  // Landing
  home: "/",
  howItWorks: "/how-it-works",
  useCases: "/use-cases",
  pricing: "/pricing",
  termsOfUse: "/terms-of-use",
  privacyPolicy: "/privacy-policy",
  contactUs: "/contact-us",
  faqs: "/faqs",
  talentEnablement: "/talent-enablement",
  talentEnablementPreview: "/talent-enablement/preview",

  // Events
  events: (slug: string) => `/events/${slug}`,

  // Auth
  signup: "/signup",
  signin: "/signin",
  forgotPassword: "/forgot-password",
  newPassword: "/new-password",
  emailVerification: "/signup/verification",

  // Settings (retained in V2 sidebar)
  settings: "/employer/settings",


  // =============================================
  // V2 ROUTES (New Dashboard with Hiring Assistant & Manage Jobs)
  // =============================================

  // Hiring Assistant - V2
  publishAssessment: "/employer/assessment",

  // Manage Jobs - V2
  manageJobs: "/employer/manage-jobs",
  reviewTalents: (id) => `/employer/manage-jobs/review-talent/${id}`,
  reviewTalentsCVAnalysis: (id) => `/employer/manage-jobs/cv-analysis/review-talent/${id}`,
  report: ({id, id2}) => `/employer/manage-jobs/review-talent/${id}/report/${id2}`,
  analytics: (id) => `/employer/manage-jobs/review-talent/${id}/analytics`,
  compareCandidates: ({id, id2}) => `/employer/manage-jobs/review-talent/${id}/report/${id2}/comparing`,

  // Public Reports - V2
  publicReport: ({ id, role }) => `/shared-report/${role}/${id}`,

  // Candidates Assessment Flow - V2
  candidateAssessment: (id) => `/candidate-assessment/${id}`,
  assessment: (id) => `/take-assessment/${id}`,
  assessmentFeedback: (id) => `/assessment-feedback/${id}`,

  // Credits & Billing
  creditsBilling: "/employer/pricing",
};
